import { Checkbox, Text } from "../../../../components";
import Localization from "../../../../localization";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import { useState } from "react";
import Section from "./section";

const Options = ({ progress, onChange = () => {}, ...props }) => {
  const { device, updateDistribution } = useViewModel();
  const [selectedOptions, setSelectedOptions] = useState(
    device.distribution.signals ?? ["burglary", "fire", "emergency"]
  );

  return (
    <Section {...props}>
      <Text
        level={5}
        weight={700}
        type="secondary"
        className="m-15-b"
        children={Localization.service_edit_alarm_operator.actions_title}
      />
      <Checkbox.Group
        vertical
        value={selectedOptions}
        options={Object.values(Enums.alarmSMScategories).map((value) => ({
          label: Enums.details("alarmSMScategories", value)?.name ?? "",
          value: value,
        }))}
        onChange={(signals) => {
          updateDistribution({ signals, progress });
          setSelectedOptions(signals);
        }}
      />
    </Section>
  );
};

export default Options;
